export const KB_BUTTON_TOOLTIP = "Knowledge base";

export const AI_KB_MENU_CLICK = "AI_KB_MENU_CLICK";
export const AI_KB_GENERATE_CLICK = "AI_KB_GENERATE_CLICK";
export const AI_KB_REGENERATE_CLICK = "AI_KB_REGENERATE_CLICK";
export const AI_KB_PREVIEW = "AI_KB_PREVIEW";
export const AI_KB_FEEDBACK = "AI_KB_FEEDBACK";
